import { noop } from '@utils/noop';
import { Dispatch, createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ObjectSchema, mixed, object, string } from 'yup';

export type RevokeType = 'playerIds' | 'fullRevoke' | 'requestId';

export type RevokeFreebetsFormState = {
  campaignId: string;
  revokeType: RevokeType;
  file: File | null;
  requestId: string;
};

export const revokeFreebetsFormStateDefault: RevokeFreebetsFormState = {
  campaignId: '',
  revokeType: 'playerIds',
  file: null,
  requestId: '',
};

export const revokeFreebetsSchemaDefault: ObjectSchema<Partial<RevokeFreebetsFormState>> = object<
  Partial<RevokeFreebetsFormState>
>().shape({
  campaignId: string().required('request id is required field'),
  revokeType: mixed<RevokeType>()
    .oneOf(['playerIds', 'fullRevoke', 'requestId'])
    .required('revoke type is required field'),
  file: mixed<File>().nullable(),
  requestId: string(),
});

type RevokeFreebetsFormContextType = {
  schema: ObjectSchema<Partial<RevokeFreebetsFormState>>;
  setSchema: Dispatch<ObjectSchema<Partial<RevokeFreebetsFormState>>>;
  methods?: UseFormReturn<RevokeFreebetsFormState>;
};

const revokeFreebetsFormContextDefault = {
  schema: revokeFreebetsSchemaDefault,
  setSchema: noop,
} satisfies RevokeFreebetsFormContextType;

export const RevokeFreebetsFormContext = createContext<RevokeFreebetsFormContextType>(
  revokeFreebetsFormContextDefault
);

export const useRevokeFreebetsForm = () => {
  const { methods } = useContext(RevokeFreebetsFormContext);

  if (!methods) {
    throw new Error('RevokeFreebetsFormContext is empty');
  }

  return methods;
};

export const useManageRevokeFreebetsSchema = () => {
  const { setSchema } = useContext(RevokeFreebetsFormContext);

  return { setSchema };
};
